var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},_vm._l((_vm.permissions),function(item){return _c('ejs-chiplist',{key:item,attrs:{"text":item,"cssClass":_vm.color(item)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }